/**************************************************
 * Nombre:       Dialogo_Detalle_Campana
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Detalle_Campana from "../Formularios/Formulario_Detalle_Campana";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {obtenerSaldo} from "../../CodNegocio/Saldos/obtenerSaldo";
import Tarjeta_Funnel_Pq from "../Tarjetas/Tarjeta_Funnel_Pq";
import {crearInversion} from "../../CodNegocio/Depositos/crearInversion";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {crearLinkCampana} from "../../CodNegocio/Campana/crearLinkCampana";
import {enviarPeticion} from "../../Modulo_Peticiones/Peticiones/enviarPeticion";

const Dialogo_Detalle_Campana = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const [numSaldo, setNumSaldo] = useState(0)


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        if (entidad.valor < 1) {
            nuevoAviso({aviso: 'El valor de inversion debe ser mayor a 1 ', variante: 'error'})
            return
        }

        if (entidad.valor > numSaldo) {
            nuevoAviso({
                aviso: 'El valor de inversion debe ser menor o igual al saldo disponible',
                variante: 'error'
            })
            return
        }


        if (entidad.numDias > entidad.valor) {
            nuevoAviso({
                aviso: 'El valor de inversion debe ser menor que el numero de dias que correra el anuncio',
                variante: 'error'
            })
            return
        }

        iniciarCarga('Subiendo Datos')

        if (!entidad.id) {
            entidad.id = new Date().getTime() + 'NAS'
        }

        entidad.idUsuario = cData.usuario.id
        entidad.correo = cData.usuario.correo
        entidad.nombreUsuario = cData.usuario.nombres + ' ' + cData.usuario.apellidos
        entidad.estado = 'Iniciando'
        entidad.link = crearLinkCampana({idFunnel: entidad.idFunnel, idUsuario: entidad.idUsuario})
        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'campanas'})
        entidad.consecutivo = conse.data


        let dox = await guardarDoc('campanas', entidad)
        if (dox.res) {
            // debo recargar pagina
            // debo realizar un deposito tipo Inversion para deducir el saldo\
            await crearInversion({
                usuario: cData.usuario,
                valor: entidad.valor,
                idCampana: dox.data,
                conseCapana: conse.data
            })
            await aumentarConsecutivo({col: 'consecutivos', id: 'campanas', actual: conse.data})
            await enviarPeticion({datos: entidad, flujo: 'noti_campana'})
            terminar({aviso: 'Datos subidos con exito'})
            realizado()
            cerrar()

        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    useEffect(() => {

        let idUsuario = cData.usuario.id
        obtenerSaldo({idUsuario: idUsuario}).then((dox) => {
            setNumSaldo(dox)
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tarjeta_Funnel_Pq item={datos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontWeight: 600}}>{`Presupesto (Saldo en cuenta $ ${numSaldo} USD)`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                <Formulario_Detalle_Campana props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Detalle_Campana